(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.controller('UserWebsiteRemoveQuestionController', ['$uibModalInstance', UserWebsiteRemoveQuestionControllerFn]);

    /* controller for question box */
    function UserWebsiteRemoveQuestionControllerFn ($uibModalInstance) {
        var vm = this;
         
        // close no
        vm.no = function () {
            $uibModalInstance.close(false);
        };

        // close yes
        vm.yes = function () {
            $uibModalInstance.close(true);
        };
    }

})();